import { render, staticRenderFns } from "./AddResourcePage.html?vue&type=template&id=be5cac2a&external"
import script from "./AddResourcePage.js?vue&type=script&lang=js&external"
export * from "./AddResourcePage.js?vue&type=script&lang=js&external"
import style0 from "./AddResourcePage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports